// import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccountUserService } from 'src/app/service/account.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class LogService {

  appUrl = "";
  user: any;
  activityUrl = "";
  apiUrlAccount = "";

  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.apiUrl;
    this.activityUrl = environment.activity + '/LionO360/2.0/API/';
    this.apiUrlAccount = environment.apiUrlAccount;
  }



  addLog(log) {
    return this.http.post(this.appUrl + "ObjectLog", log).toPromise().then(res => res);
  }

  updateLog(log) {
    return this.http.put(this.appUrl + "Log", log).toPromise().then(res => res);
  }

  getLogTypes() {
    return this.http.get(this.activityUrl + "LogType").toPromise().then(res => res)
  }

  getSubLogTypes(logTypeId) {
    return this.http.get(this.activityUrl + "SubLogType?logTypeId="+logTypeId).toPromise().then(res => res)
  }

  getActivityTypes(groupId: number) {
    return this.http.get(this.activityUrl + "Type?groupId=" + groupId).toPromise().then(res => res)
  }

  getGroupByName(name: string) {
    return this.http.get(this.activityUrl + "Group/Name?name=" + name).toPromise().then(res => res)
  }

  getTypesByGroupName(name: string) {
    return this.http.get(this.activityUrl + "Type/Group/" + name).toPromise().then(res => res)
  }

  getLogById(id) {
    return this.http.get(this.activityUrl + "log/"+id).toPromise().then(res => res)
  }
}
